import update from '@scoir/immutability'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.UPDATE_COLLAPSE_ACADEMIC_OVERVIEW:
      return update(state, {
        academicOverview: { $set: action.payload },
      })
    case types.UPDATE_COLLAPSE_APPLICATION_STATUS:
      return update(state, {
        applicationStatus: { $set: action.payload },
      })
    case types.UPDATE_COLLAPSE_CHECKLIST:
      return update(state, {
        checklist: { $set: action.payload },
      })
    case types.UPDATE_COLLAPSE_DOCUMENT_STATUS:
      return update(state, {
        documentStatus: { $set: action.payload },
      })
    case types.UPDATE_COLLAPSE_SCATTERGRAM:
      return update(state, {
        scattergram: { $set: action.payload },
      })
    case types.UPDATE_COLLAPSE_PROSPECT_HISTORY:
      return update(state, {
        history: { $set: action.payload },
      })
    default:
      return state
  }
}
